export const stickyTableCellClass = `sticky z-30 bg-gray-300 top-10`;
